//src/context/NotificationContext.jsx
import React, { createContext, useContext, useEffect, useState } from "react";
import {
  addDoc,
  collection,
  doc,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
  where,
  writeBatch,
  arrayUnion,
  
} from "firebase/firestore";
import { db } from "../firebase/config";
import { useAuth } from "./AuthContext";

const NotificationContext = createContext(null);

export const useNotifications = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error("useNotifications must be used inside NotificationProvider");
  }
  return context;
};

export function NotificationProvider({ children }) {
  const { userProfile } = useAuth();

  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  const uid = userProfile?.uid;
  const teamId = userProfile?.teamId;
  const department = userProfile?.department;
  const role = userProfile?.role;

  useEffect(() => {
    if (!uid) {
      setNotifications([]);
      setUnreadCount(0);
      return;
    }

    const recipients = [
    uid,
    "all",
    teamId,
    department,
    role === "lead" ? "leads" : null,
    role === "admin" ? "admins" : null,
].filter(Boolean);

    const q = query(
      collection(db, "notifications"),
      where("recipientId", "in", recipients),
      
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {

      const startOfToday = new Date();
startOfToday.setHours(0, 0, 0, 0);
const data = snapshot.docs.map((doc) => ({
  id: doc.id,
  ...doc.data(),
}));

data.sort((a, b) => {
  if (!a.createdAt || !b.createdAt) return 0;
  return b.createdAt.toMillis() - a.createdAt.toMillis();
});

setNotifications(data);




      setUnreadCount(
        data.filter((n) => !(n.readBy || []).includes(uid)).length
      );
    });

    return unsubscribe;
  }, [uid, teamId, department, role]);

  const addNotification = async ({
    title,
    message,
    type = "general",
    priority = "normal",
    recipientId,
    recipientType = "user",
    actionUrl = "",
    metadata = {},
    createdBy = uid,
  }) => {
    await addDoc(collection(db, "notifications"), {
      title,
      message,
      type,
      priority,
      recipientId,
      recipientType,
      actionUrl,
      metadata,
      createdBy,
      readBy: [],
      createdAt: serverTimestamp(),
      expiresAt: new Date(Date.now() + 24*60*60*1000 ), // Expires in 1 days
    });
  };

  const markAsRead = async (notificationId) => {
  if (!uid) return;

  try {
    await updateDoc(doc(db, "notifications", notificationId), {
      readBy: arrayUnion(uid),
    });
  } catch (error) {
    console.error("Error marking notification as read:", error);
  }
};
  const markAllAsRead = async () => {
    if (!uid) return;

    const batch = writeBatch(db);

    notifications.forEach((n) => {
      if (!(n.readBy || []).includes(uid)) {
        batch.update(doc(db, "notifications", n.id), {
  readBy: arrayUnion(uid),
});
      }
    });

    await batch.commit();
  };

  const deleteNotification = async (notificationId) => {
    await updateDoc(doc(db, "notifications", notificationId), {
      deleted: true,
    });
  };

  return (
    <NotificationContext.Provider
      value={{
        notifications: notifications.filter((n) => !n.deleted),
        unreadCount,
        addNotification,
        markAsRead,
        markAllAsRead,
        deleteNotification,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
}